export const GET_TABLES_API = "/tables/";

export const ADD_TABLE_API = "/tables/";

export const DELETE_TABLE_API = "/tables/";

export const UPDATE_TABLE_API = "/tables/";

export const GET_TABLELINKS_API = "/tables/tablelinks/";

export const ADD_TABLELINK_API = "/tables/tablelinks/";

export const DELETE_TABLELINK_API = "/tables/tablelinks/";

export const UPDATE_TABLELINK_API = "/tables/tablelinks/";

export const GET_TABLE_TYPES_API = "/tables/types/";


// WEBPACK FOOTER //
// ./src/apis/tables.js